module.exports = __webpack_public_path__ + "static/pie_painter_2-77ecba4f0706ad496fa1722595941b92.png";